import React from 'react'
export default function About({ profile, lang, t, interests }) {
  return (
    <section className="section" id="about">
      <div className="container about-grid">
        <div>
          <p className="eyebrow">{t.about}</p>
          <h2>
            {lang === 'en'
              ? 'Engineering experience with a practical mindset.'
              : 'Experiencia en ingeniería con una visión práctica.'}
          </h2>
          <p className="about-copy">{profile.about[lang]}</p>
          <div className="traits">
            <span>✦ {t.ai}</span>
            <span>◆ {t.problem}</span>
            <span>ϟ {t.learner}</span>
            <span>▱ {t.remote}</span>
            <span>◎ {t.opportunities}</span>
          </div>
        </div>
        <div>
          <p className="eyebrow">{t.interests}</p>
          <div className="interest-list">
            {interests[lang].map((x, i) => (
              <span key={x}>
                <b>0{i + 1}</b>
                {x}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
